export const FETCH_ALL_REVIEWER_COMPLETED_APPLICATIONS = 'FETCH_ALL_REVIEWER_COMPLETED_APPLICATIONS'
export const FETCH_ALL_REVIEWER_REVIEWED_APPLICATIONS = 'FETCH_ALL_REVIEWER_REVIEWED_APPLICATIONS'